module.exports = __webpack_public_path__ + "img/main-2_m.925bf007.webp";